namespace Matrix.Indexation {
    export interface DimIndexationProfileForm {
        DateKey: Serenity.DateEditor;
        ArchivedBy: Serenity.StringEditor;
        ArchivedWhen: Serenity.StringEditor;
        IndexationProfileCode: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        IndexationInstanceId: Serenity.StringEditor;
        EffectiveDate: Serenity.DateEditor;
        ValidFrom: Serenity.StringEditor;
        ValidTo: Serenity.StringEditor;
        ShortName: Serenity.StringEditor;
        RowId: Serenity.IntegerEditor;
        Version: StaticTextBlock;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        DefaultSortOrder: Serenity.IntegerEditor;
    }

    export class DimIndexationProfileForm extends Serenity.PrefixedContext {
        static formKey = 'Indexation.DimIndexationProfile';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DimIndexationProfileForm.init)  {
                DimIndexationProfileForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = StaticTextBlock;
                var w4 = ReadOnlyDateTime;

                Q.initFormType(DimIndexationProfileForm, [
                    'DateKey', w0,
                    'ArchivedBy', w1,
                    'ArchivedWhen', w1,
                    'IndexationProfileCode', w1,
                    'Name', w1,
                    'IndexationInstanceId', w1,
                    'EffectiveDate', w0,
                    'ValidFrom', w1,
                    'ValidTo', w1,
                    'ShortName', w1,
                    'RowId', w2,
                    'Version', w3,
                    'CreatedBy', w3,
                    'CreatedWhen', w4,
                    'UpdatedBy', w3,
                    'UpdatedWhen', w4,
                    'DefaultSortOrder', w2
                ]);
            }
        }
    }
}
